














































































import CompanyUserRequired from "@/components/CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {companyroleid, DateTime} from "@/modules/models";
import {DataUseReport} from "@/modules/terminalDataUseReport";
import Api from "src/components/super/Api";

const right = "right";
const numFormatter = new Intl.NumberFormat();

@Component({
})
export default class SuperTerminalDataUsage extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop()
  guid!: string;

  dataUsageHeaders = [
    {text: "id", value: "id", align: right, sortable: true},
    {text: "reported", value: "reportTime", align: right, sortable: true},
    {text: "summeringstid (minutter)", value: "accumulationTimeMinutes", align: right, sortable: true},
    {text: "total rx", value: "totalRxKb", align: right, sortable: true},
    {text: "total tx", value: "totalTxKb", align: right, sortable: true},
    {text: "AT rx", value: "atRxKb", align: right, sortable: true},
    {text: "AT tx", value: "atTxKb", align: right, sortable: true},
    {text: "mobile rx", value: "mobileRxKb", align: right, sortable: true},
    {text: "mobile tx", value: "mobileTxKb", align: right, sortable: true},
  ]

  dataUsageLines: DataUseReport[] = [];
  noDataLoaded = false;

  formatNum(n: number | null): string {
    return n !== null ? numFormatter.format(n): "";
  }

  calcLineNumClass(n: number | null): string | null {
    if (n !== null) {
      if (n > 1024 * 1024) {
        return "error--text num-error"
      }
      if (n > 1024) {
        return "warning--text num-warn"
      }
    }
    return null
  }

  calcSumNumClass(n: number | null): string | null {
    const warnLimit = 50 * 1024; // We warn when some sum is above 50MB, since that's the per device datapool factor
    const errorLimit = 500 * 1024; // If sum is above 500MB something is definetly wrong
    if (n !== null) {
      if (n > errorLimit) {
        return "error--text num-error"
      }
      if (n > warnLimit) {
        return "warning--text num-warn"
      }
    }
    return null;
  }

  get sumDataUsage(): DataUseReport {
    if(this.dataUsageLines.length === 0) {
      return DataUseReport.empty();
    }
    if(this.dataUsageLines.length === 1) {
      return this.dataUsageLines[0];
    }
    return this.dataUsageLines.reduce((a: DataUseReport, b: DataUseReport) => a.plus(b));
  }

  @Watch("guid", {immediate: true})
  async loadReport() {
    this.noDataLoaded = false;
    if (this.guid && this.guid.length > 5) {
      this.dataUsageLines = await this.api.getDataUseReport(this.guid);
      if(this.dataUsageLines.length === 0) {
        this.noDataLoaded = true;
      }
    }
  }

  created() {
    this.requireCompanyRoles([companyroleid.super]);
  }
}
